import { SortConfig } from "../types/jobFilters";
import { CSV_EXTENSION, EXCEL_EXTENSION } from "./app";

export const MAX_JOBS = 2_500;

export const DEFAULT_SORT_CONFIG = {
    field: "",
    limit: MAX_JOBS,
    skip: 0,
    ascending: false,
    status: 0,
} as SortConfig;

export enum JobImportDefaultFields {
    "ID",
    "Title",
    "Place Name",
    "Address",
    "City",
    "State",
    "Country",
    "Type",
    "Assignee",
    "Team",
    "Date",
    "Order",
    "Priority",
    "Contact Name",
    "Contact Phone",
    "Time Window",
    "On Site (minutes",
    "Notes",
    "Auto-assign",
    "Carry Over",
    "Email On Completion",
    "Email On Issue",
}

export enum JobImportAdvancedFields {
    "Latitude",
    "Longitude",
    "Attachments",
    "Contact E-mail",
    "Sort Number",
    "Pick-up",
    "Drop-off",
    "Linked Forms",
    "Linked Zones",
    "Required Skills",
}

export const IMPORT_JOB_FILE_FORMATS = [CSV_EXTENSION, EXCEL_EXTENSION];

export const ALL_JOBS_SELECT_COLUMN = "select";
export const ALL_JOBS_ID_COLUMN = "id";
export const ALL_JOBS_NUMBER_COLUMN = "number";
export const ALL_JOBS_TITLE_COLUMN = "title";
export const ALL_JOBS_ASSIGNEE_COLUMN = "assignee";
export const ALL_JOBS_PROGRESS_STATUS_COLUMN = "progressStatus";
export const ALL_JOBS_ASSIGNED_DATE_COLUMN = "assignedDate";
export const ALL_JOBS_PRIORITY_COLUMN = "priority";
export const ALL_JOBS_ADDRESS_COLUMN = "address";
export const ALL_JOBS_TEAM_COLUMN = "team";
export const ALL_JOBS_CREATED_DATE_COLUMN = "createdDate";
export const ALL_JOBS_CREATED_BY_COLUMN = "createdBy";
export const ALL_JOBS_LAST_SAVED_COLUMN = "lastSaved";
export const ALL_JOBS_ORDER_NUMBER_COLUMN = "ordenNumber";
export const ALL_JOBS_ONSITE_COLUMN = "onsite";
export const ALL_JOBS_PICKUP_COLUMN = "pickup";
export const ALL_JOBS_DROPOFF_COLUMN = "dropoff";
export const ALL_JOBS_NOTES_COLUMN = "notes";
export const ALL_JOBS_OPTIONS_COLUMN = "options";
export const ALL_JOBS_TIME_WINDOW_COLUMN = "timeWindow";
export const ALL_JOBS_ZONES = "zones";
export const ALL_JOBS_WORK_TYPE = "workType";
export const ALL_JOBS_CARRY_OVER = "carryOver";
export const ALL_JOBS_LABELS = "labels";
export const ALL_JOBS_JOB_GROUP = "jobGroup";
export const ALL_JOBS_REQUIRED_SKILLS = "requiredSkills";
export const ALL_JOBS_RECURRING_ROUTE = "recurringRoute";

export const ALL_JOBS_ALL_COLUMNS = [
    ALL_JOBS_ID_COLUMN,
    ALL_JOBS_NUMBER_COLUMN,
    ALL_JOBS_TITLE_COLUMN,
    ALL_JOBS_ASSIGNEE_COLUMN,
    ALL_JOBS_PROGRESS_STATUS_COLUMN,
    ALL_JOBS_ASSIGNED_DATE_COLUMN,
    ALL_JOBS_PRIORITY_COLUMN,
    ALL_JOBS_ADDRESS_COLUMN,
    ALL_JOBS_TEAM_COLUMN,
    ALL_JOBS_CREATED_BY_COLUMN,
    ALL_JOBS_RECURRING_ROUTE,
    ALL_JOBS_CREATED_DATE_COLUMN,
    ALL_JOBS_LAST_SAVED_COLUMN,
    ALL_JOBS_TIME_WINDOW_COLUMN,
    ALL_JOBS_ORDER_NUMBER_COLUMN,
    ALL_JOBS_NOTES_COLUMN,
    ALL_JOBS_ZONES,
    ALL_JOBS_WORK_TYPE,
    ALL_JOBS_CARRY_OVER,
    ALL_JOBS_ONSITE_COLUMN,
    ALL_JOBS_PICKUP_COLUMN,
    ALL_JOBS_DROPOFF_COLUMN,
    ALL_JOBS_LABELS,
    ALL_JOBS_REQUIRED_SKILLS,
    ALL_JOBS_JOB_GROUP,
];

export const ALL_JOBS_DEFAULT_COLUMNS = ALL_JOBS_ALL_COLUMNS.filter(col => {
    return col !== ALL_JOBS_PICKUP_COLUMN
        && col !== ALL_JOBS_DROPOFF_COLUMN
        && col !== ALL_JOBS_ZONES
        && col !== ALL_JOBS_ID_COLUMN
        && col !== ALL_JOBS_LABELS
        && col !== ALL_JOBS_REQUIRED_SKILLS
        && col !== ALL_JOBS_RECURRING_ROUTE
});

export const ALL_JOBS_MEMBER_ALL_COLUMNS = [
    ALL_JOBS_ID_COLUMN,
    ALL_JOBS_NUMBER_COLUMN,
    ALL_JOBS_TITLE_COLUMN,
    ALL_JOBS_PROGRESS_STATUS_COLUMN,
    ALL_JOBS_PRIORITY_COLUMN,
    ALL_JOBS_ADDRESS_COLUMN,
    ALL_JOBS_TEAM_COLUMN,
    ALL_JOBS_CREATED_DATE_COLUMN,
    ALL_JOBS_LAST_SAVED_COLUMN,
    ALL_JOBS_TIME_WINDOW_COLUMN,
    ALL_JOBS_ORDER_NUMBER_COLUMN,
    ALL_JOBS_NOTES_COLUMN,
    ALL_JOBS_ZONES,
    ALL_JOBS_WORK_TYPE,
    ALL_JOBS_CARRY_OVER,
    ALL_JOBS_ONSITE_COLUMN,
    ALL_JOBS_PICKUP_COLUMN,
    ALL_JOBS_DROPOFF_COLUMN,
    ALL_JOBS_LABELS,
    ALL_JOBS_REQUIRED_SKILLS,
    ALL_JOBS_JOB_GROUP,
];

export const ALL_JOBS_MEMBER_DEFAULT_COLUMNS = ALL_JOBS_MEMBER_ALL_COLUMNS.filter(col => {
    return col !== ALL_JOBS_ID_COLUMN && col !== ALL_JOBS_REQUIRED_SKILLS;
});

export const ALL_JOBS_DEFAULT_COLUMNS_WIDTH = {
    [ALL_JOBS_SELECT_COLUMN]: 50,
    [ALL_JOBS_ID_COLUMN]: 180,
    [ALL_JOBS_NUMBER_COLUMN]: 46,
    [ALL_JOBS_TITLE_COLUMN]: 250,
    [ALL_JOBS_ASSIGNEE_COLUMN]: 150,
    [ALL_JOBS_PROGRESS_STATUS_COLUMN]: 100,
    [ALL_JOBS_ASSIGNED_DATE_COLUMN]: 130,
    [ALL_JOBS_PRIORITY_COLUMN]: 90,
    [ALL_JOBS_ADDRESS_COLUMN]: 240,
    [ALL_JOBS_TEAM_COLUMN]: 140,
    [ALL_JOBS_CREATED_BY_COLUMN]: 170,
    [ALL_JOBS_RECURRING_ROUTE]: 180,
    [ALL_JOBS_CREATED_DATE_COLUMN]: 170,
    [ALL_JOBS_LAST_SAVED_COLUMN]: 170,
    [ALL_JOBS_ORDER_NUMBER_COLUMN]: 140,
    [ALL_JOBS_NOTES_COLUMN]: 250,
    [ALL_JOBS_OPTIONS_COLUMN]: 35,
    [ALL_JOBS_TIME_WINDOW_COLUMN]: 110,
    [ALL_JOBS_ZONES]: 150,
    [ALL_JOBS_WORK_TYPE]: 100,
    [ALL_JOBS_CARRY_OVER]: 120,
    [ALL_JOBS_ONSITE_COLUMN]: 70,
    [ALL_JOBS_PICKUP_COLUMN]: 70,
    [ALL_JOBS_DROPOFF_COLUMN]: 70,
    [ALL_JOBS_LABELS]: 70,
    [ALL_JOBS_REQUIRED_SKILLS]: 180,
    [ALL_JOBS_JOB_GROUP]: 180,
}

export const ALL_JOBS_MEMBER_DEFAULT_COLUMNS_WIDTH = {
    [ALL_JOBS_SELECT_COLUMN]: 50,
    [ALL_JOBS_ID_COLUMN]: 180,
    [ALL_JOBS_NUMBER_COLUMN]: 46,
    [ALL_JOBS_TITLE_COLUMN]: 250,
    [ALL_JOBS_PROGRESS_STATUS_COLUMN]: 100,
    [ALL_JOBS_PRIORITY_COLUMN]: 90,
    [ALL_JOBS_ADDRESS_COLUMN]: 240,
    [ALL_JOBS_TEAM_COLUMN]: 140,
    [ALL_JOBS_CREATED_BY_COLUMN]: 170,
    [ALL_JOBS_RECURRING_ROUTE]: 180,
    [ALL_JOBS_CREATED_DATE_COLUMN]: 170,
    [ALL_JOBS_LAST_SAVED_COLUMN]: 170,
    [ALL_JOBS_ORDER_NUMBER_COLUMN]: 140,
    [ALL_JOBS_NOTES_COLUMN]: 250,
    [ALL_JOBS_OPTIONS_COLUMN]: 65,
    [ALL_JOBS_TIME_WINDOW_COLUMN]: 110,
    [ALL_JOBS_ZONES]: 150,
    [ALL_JOBS_WORK_TYPE]: 100,
    [ALL_JOBS_CARRY_OVER]: 120,
    [ALL_JOBS_ONSITE_COLUMN]: 70,
    [ALL_JOBS_PICKUP_COLUMN]: 70,
    [ALL_JOBS_DROPOFF_COLUMN]: 70,
    [ALL_JOBS_LABELS]: 70,
    [ALL_JOBS_REQUIRED_SKILLS]: 180,
    [ALL_JOBS_JOB_GROUP]: 180,
}

// Prefix marking a grid column as a built-in form field. The column id is
// `${FORM_FIELD_COLUMN_PREFIX}${fieldName}` so form columns never collide with
// system columns or company custom fields.
export const FORM_FIELD_COLUMN_PREFIX = "form:";

export const ALL_JOBS_GRID_DEFAULT_TYPE = "all";
export const ALL_JOBS_GRID_MEMBER_TYPE = "member";

/** Jobs the GPU map layer draws at most; past it the Layers panel says how many are left out. */
export const MAX_JOBS_ON_MAP = 5000;

// The first 16 slots remain compatible with legacy mobile clients. Current
// clients can use the backend's dynamic overflow attachment collection.
export const MAX_JOB_ATTACHMENTS = 250;
